export type EntityKind = 'person' | 'vehicle';

export type IdentityToken =
    | `${EntityKind}:${string}`
    | `undefined:${EntityKind}`;

export enum IdentityKnownFilter {
    ALL = 'all',
    KNOWN = 'known',
    UNKNOWN = 'unknown',
}

export interface Identity {
    id: string;
    kind: EntityKind;
    name: string | null;
    licensePlate: string | null;
    known: boolean;
    tags: string[];
    thumbnailUrl: string;
}
